import { AdminDropdownsBaseController } from './admin_dropdowns_base_controller';
import Rails from "@rails/ujs";

let debounce = require('lodash/debounce');

export default class extends AdminDropdownsBaseController {
  static targets = ['component', 'menu', 'icon', 'menuItem', 'hiddenField'];

  static values = {
    url: String,
    method: String
  }

  connect() {
    this.toggleOptionAll = debounce(this.toggleOptionAll, 150).bind(this);
  }

  toggleMenu(event) {
    this.closeAnyOpenMenu();
    this.positionMenu(event.target);
    this.showMenu();

    // This will reduce the number of events fired on the page by only listening to clicks when a
    // menu is open, and only listening to resize event when a menu is open.
    if (this.menuTarget.classList.contains('open')) {
      document.addEventListener('click', this.clickOutsideHandler);
      window.addEventListener('resize', this.resizeHandler);
    } else {
      document.removeEventListener('click', this.clickOutsideHandler);
      window.removeEventListener('resize', this.resizeHandler);
    }
  }

  toggleOption() {
    this._toggleOption();
  }

  toggleOptionAll() {
    this._toggleOption();
  }

  _toggleOption() {
    let checkedItems = [];
    this.menuItemTargets.forEach((item) => {
      if (item.querySelector('input[type="checkbox"]').checked) {
        checkedItems.push(item.dataset.value);
      }

    });

    this.hiddenFieldTarget.value = checkedItems.join(' ');

    if (this.urlValue === undefined || this.urlValue === '') return;

    this._loadData();
  }

  _loadData() {
    if (this.ajaxRequest) {
      this.ajaxRequest.abort(); // Abort previous ajax request.
    }

    Rails.ajax({
      url: this._url(),
      type: this.methodValue,
      body: this._body(),
      dataType: "script",
      beforeSend: (xhr) => {
        this.ajaxRequest = xhr;
        return true;
      }
    })
  }

  _url() {
    const hasQuery = this.urlValue.includes('?');
    const separator = hasQuery ? '&' : '?';

    if (this.methodValue === 'get') {
      const { name, value } = this.hiddenFieldTarget;
      return `${this.urlValue}${separator}${name}=${encodeURIComponent(value)}`;
    } else {
      return this.urlValue;
    }
  }

  _body() {
    if (this.methodValue === 'get') {
      return {};
    } else {
      const body = new FormData();

      return body.append(this.hiddenFieldTarget.name, this.hiddenFieldTarget.value);
    }
  }
}
